import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconConstantContact = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 27 27",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.79 13.377c1.56-.4 3.15-.683 4.755-.845a33.576 33.576 0 0 1 1.12-3.53l-.147.026a33.512 33.512 0 0 0-4.494 1.178 32.973 32.973 0 0 0-1.234 3.17ZM8.87 11.79a34.658 34.658 0 0 1 1.583-2.874 41.716 41.716 0 0 0-2.584 1.61 34 34 0 0 0-1.791 2.899 34.354 34.354 0 0 1 2.792-1.634",
			fill: "#FCD98D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.138 13.552c.333-1.048.718-2.08 1.152-3.09a34.104 34.104 0 0 0-3.997 1.748 33.241 33.241 0 0 0-1.186 2.775 30.588 30.588 0 0 1 4.03-1.434",
			fill: "#809EBA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.429 8.465c.162-.03.321-.059.479-.085a35.004 35.004 0 0 1 1.652-3.527 36.573 36.573 0 0 0-4.413 1.364 34.61 34.61 0 0 0-1.796 3.281 34.105 34.105 0 0 1 4.078-1.033ZM3.594 17.46c.285-.759.606-1.525.958-2.281-.598.445-1.182.909-1.75 1.391a32.695 32.695 0 0 0-1.41 2.53 28.226 28.226 0 0 1 2.202-1.64Z",
			fill: "#2B5E8C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.387 15.312c.32-.9.678-1.787 1.074-2.656a34.28 34.28 0 0 0-2.944 1.829 32.378 32.378 0 0 0-1.112 2.45 28.866 28.866 0 0 1 2.983-1.623",
			fill: "#F9B31B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.145 12.476a32.68 32.68 0 0 1 5.274-.03c.398-1.406.82-2.735 1.287-3.984l-.233-.001c-1.682 0-3.417.144-5.156.427a32.72 32.72 0 0 0-1.172 3.588Z",
			fill: "#809EBA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.47 7.891c.157 0 .308.001.453.004a29.848 29.848 0 0 1 1.867-3.924 32.071 32.071 0 0 0-5.49.713 34.563 34.563 0 0 0-1.736 3.588 32.61 32.61 0 0 1 4.906-.38Zm-12.684 9.344a32.001 32.001 0 0 1 4.986-.46c.122-1.18.335-2.408.63-3.656a31.95 31.95 0 0 0-4.817.9 29.767 29.767 0 0 0-.799 3.216Z",
			fill: "#F9B31B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.628 20.524c.177-.7.391-1.42.636-2.143A28.02 28.02 0 0 0 .79 20.372 27.621 27.621 0 0 0 0 22.347a22.603 22.603 0 0 1 2.628-1.823Z",
			fill: "#FCD98D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.19 17.342c.193-1.06.443-2.108.749-3.141-1.402.41-2.772.92-4.1 1.53-.31.897-.578 1.809-.801 2.732a28.75 28.75 0 0 1 4.153-1.12",
			fill: "#2B5E8C"
		})
	]
});
export default SvgIconConstantContact;
